/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from 'react'
import InputBox from '../../components/InputBox'
import Dropdown from '../../components/Dropdown'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import InputTimer from '../../components/InputTimer'
import { convertEpochToDateFormat } from '../../CommonMethods/DateConversion'

export default function AddManageMoitoringCondTemplate({ edit,
    setTemplateName,
    bloodGlucose,
    setBloodGlucose,
    bloodPressure,
    setBloodPressure,
    spo2,
    setSpo2,
    pulse,
    setPulse,
    temprature,
    setTemprature,
    weight,
    setWeight,
    isBGCheckboxChecked,
    setBGCheckboxChecked,
    isBPCheckboxChecked,
    setBPCheckboxChecked,
    isSPO2CheckboxChecked,
    setSPO2CheckboxChecked,
    isPulseCheckboxChecked,
    setPulseCheckboxChecked,
    isTempCheckboxChecked,
    setTempCheckboxChecked,
    isWeightCheckboxChecked,
    setWeightCheckboxChecked,
    emptyField,
    setEmptyField,
    isDisableCanel,
    setIsDisableCancel,
    isPatient,
    setChooseTemplate,
    setIsAnyFieldFilled,
    submitSelected,
    setSubmitSelected,
    unittype,
    unittype1,
    unittype2,
    unittype3,
    unittype4,
    unittype5,
    data}) {


    const { id } = useParams()
 
    const dispatch = useDispatch()
    
    
    // for blood glucose
    const handleBGCheckboxChange = () => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false)
        setBGCheckboxChecked(!isBGCheckboxChecked);

        // Reset values when the checkbox is unchecked
        if (!isBGCheckboxChecked) {
            setBloodGlucose({
                startTimeMoniHourBG: '',
                startTimeMoniMinuteBG: '',
                frequency: '',
                time_period: 'Day(s)',
                maximumTimeDelayHourBG: '',
                maximumTimeDelayMinuteBG: '',
                lower_Threshold: '',
                upper_Threshold: '',
                isAMorPM: 'AM'
            });
        }
    };
    // for blood glucose
    const handleBPCheckboxChange = () => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setEmptyField(false)
        setIsDisableCancel(false)
        setBPCheckboxChecked(!isBPCheckboxChecked);

        // Reset values when the checkbox is unchecked
        if (!isBPCheckboxChecked) {
            setBloodPressure({
                startTimeMoniHourBP: '',
                startTimeMoniMinuteBP: '',
                frequencyBP: '',
                time_periodBP: 'Day(s)',
                maximumTimeDelayHourBP: '',
                maximumTimeDelayMinuteBP: '',
                lower_Threshold_systolicBP: '',
                upper_Threshold_systolicBP: '',
                lower_Threshold_DiastolicBP: '',
                upper_Threshold_DiastolicBP: '',
                isAMorPMBP: 'AM'
            });
        }


    };
    // for SPO2
    const handleSPO2CheckboxChange = () => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setEmptyField(false)
        setIsDisableCancel(false)
        setSPO2CheckboxChecked(!isSPO2CheckboxChecked);

        // Reset values when the checkbox is unchecked
        if (!isSPO2CheckboxChecked) {
            setSpo2({
                startTimeMoniHourSPO2: '',
                startTimeMoniMinuteSPO2: '',
                frequencySPO2: '',
                time_periodSPO2: 'Day(s)',
                maximumTimeDelayHourSPO2: '',
                maximumTimeDelayMinuteSPO2: '',
                lower_ThresholdSPO2: '',
                isAMorPMSPO2: 'AM'
            });
        }
    };
    // for Pulse
    const handlePulseCheckboxChange = () => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setEmptyField(false)
        setIsDisableCancel(false)
        setPulseCheckboxChecked(!isPulseCheckboxChecked);

        if (!isPulseCheckboxChecked) {
            setPulse({
                startTimeMoniHourPulse: '',
                startTimeMoniMinutePulse: '',
                frequencyPulse: '',
                time_periodPulse: 'Day(s)',
                maximumTimeDelayHourPulse: '',
                maximumTimeDelayMinutePulse: '',
                lower_ThresholdPulse: '',
                upper_ThresholdPulse: '',
                isAMorPMPulse: 'AM'
            });
        }
    };
    // for Temprature
    const handleTempCheckboxChange = () => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setEmptyField(false)
        setIsDisableCancel(false)
        setTempCheckboxChecked(!isTempCheckboxChecked);

        if (!isTempCheckboxChecked) {
            setTemprature({
                startTimeMoniHourTemp: '',
                startTimeMoniMinuteTemp: '',
                frequencyTemp: '',
                time_periodTemp: 'Day(s)',
                maximumTimeDelayHourTemp: '',
                maximumTimeDelayMinuteTemp: '',
                upper_ThresholdTemp: '',
                isAMorPMTemp: 'AM'
            });
        }
    };
    // for Weight
    const handleWeightCheckboxChange = () => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setEmptyField(false)
        setIsDisableCancel(false)
        setWeightCheckboxChecked(!isWeightCheckboxChecked);

        if (!isWeightCheckboxChecked) {
            setWeight({
                startTimeMoniHourWeight: '',
                startTimeMoniMinuteWeight: '',
                frequencyWeight: '',
                time_periodWeight: 'Day(s)',
                maximumTimeDelayHourWeight: '',
                maximumTimeDelayMinuteWeight: '',
                lower_ThresholdWeight: '',
                upper_ThresholdWeight: '',
                isAMorPMWeight: 'AM'
            });
        }
    };


    function handleOnChangeBloodGlouse(id, option) {
        setSubmitSelected(false)
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false);
        const fieldToUpdate = {
            startTimeMoniHourBG: 'startTimeMoniHourBG',
            startTimeMoniMinuteBG: 'startTimeMoniMinuteBG',
            frequency: 'frequency',
            time_period: 'time_period',
            maximumTimeDelayHourBG: 'maximumTimeDelayHourBG',
            maximumTimeDelayMinuteBG: 'maximumTimeDelayMinuteBG',
            lower_Threshold: 'lower_Threshold',
            upper_Threshold: 'upper_Threshold',
            isAMorPM: 'isAMorPM'
        }[id];
        const regex = /^[1-9]\d*$/;

        if (fieldToUpdate) {
            if (fieldToUpdate === "startTimeMoniHourBG" || fieldToUpdate === "startTimeMoniMinuteBG" || fieldToUpdate === 'maximumTimeDelayHourBG' || fieldToUpdate === 'maximumTimeDelayMinuteBG') {

                if ((fieldToUpdate === "startTimeMoniHourBG" || fieldToUpdate === "maximumTimeDelayHourBG")) {
                    //^(?:[0-9]|1[0-2])$
                    const validInputRegex = /^(0?[1-9]|1[0-2]|0)$|^$/

                    if (validInputRegex.test(option)) {
                        setBloodGlucose((prev) => ({
                            ...prev,
                            [fieldToUpdate]: option,
                        }));
                    }


                }
                if (fieldToUpdate === "startTimeMoniMinuteBG" || fieldToUpdate === "maximumTimeDelayMinuteBG") {
                    let validatedOption = option.trim(); // Remove leading and trailing spaces
                    // Check if the input is empty
                    if (validatedOption === "") {
                        // Allow empty input and clear the value
                        setBloodGlucose((prev) => ({
                            ...prev,
                            [fieldToUpdate]: "",
                        }));
                        return;
                    }
                
                    // Check if the input is "0", "3", "00", or "30"
                    if (validatedOption === "0" || validatedOption === "3" || validatedOption === "00" || validatedOption === "30") {
                        // Update the state with the validated option
                        setBloodGlucose((prev) => ({
                            ...prev,
                            [fieldToUpdate]: validatedOption,
                        }));
                        return;
                    }
                }
                
                
                
                
            }
            else if (fieldToUpdate === "frequency") {
                if (option.length <= 3 && /^[0-9]+$|^$/.test(option)) {
                    setBloodGlucose((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "lower_Threshold" || fieldToUpdate === "upper_Threshold") {
                // Regular expression to match the desired format
                const validInputRegex = /^(?=(?:\D*\d){0,7}\D*$)\d*(?:\.\d*)?$/;

                if (validInputRegex.test(option)) {
                    setBloodGlucose((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }

            }
            else if (fieldToUpdate === "isAMorPM") {
                let amOrpm = option === 'AM' ? 'PM' : 'AM'

                // Regular expression to match the desired format
                setBloodGlucose((prev) => ({
                    ...prev,
                    [fieldToUpdate]: amOrpm
                }))

            }
            else {
                setBloodGlucose((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }

        }
    }

    function handleOnChangeBloodPressure(id, option) {
        setSubmitSelected(false)
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false);

        const fieldToUpdate = {
            startTimeMoniHourBP: 'startTimeMoniHourBP',
            startTimeMoniMinuteBP: 'startTimeMoniMinuteBP',
            frequencyBP: 'frequencyBP',
            time_periodBP: 'time_periodBP',
            maximumTimeDelayHourBP: 'maximumTimeDelayHourBP',
            maximumTimeDelayMinuteBP: 'maximumTimeDelayMinuteBP',
            lower_Threshold_systolicBP: 'lower_Threshold_systolicBP',
            upper_Threshold_systolicBP: 'upper_Threshold_systolicBP',
            lower_Threshold_DiastolicBP: 'lower_Threshold_DiastolicBP',
            upper_Threshold_DiastolicBP: 'upper_Threshold_DiastolicBP',
            isAMorPMBP: 'isAMorPMBP'
        }[id];


        if (fieldToUpdate) {
            if (fieldToUpdate === "startTimeMoniHourBP" || fieldToUpdate === "startTimeMoniMinuteBP" || fieldToUpdate === 'maximumTimeDelayHourBP' || fieldToUpdate === 'maximumTimeDelayMinuteBP') {
                if ((fieldToUpdate === "startTimeMoniHourBP" || fieldToUpdate === "maximumTimeDelayHourBP")) {
                    //^(?:[0-9]|1[0-2])$
                    const validInputRegex = /^(0?[1-9]|1[0-2]|0)$|^$/;
                    if (validInputRegex.test(option)) {
                        setBloodPressure((prev) => ({
                            ...prev,
                            [fieldToUpdate]: option,
                        }));
                    }


                }
                if ((fieldToUpdate === "startTimeMoniMinuteBP" || fieldToUpdate === "maximumTimeDelayMinuteBP")) {
                    //^([0-5]?[0-9])$
                    let validatedOption = option.trim(); // Remove leading and trailing spaces
                    // Check if the input is empty
                    if (validatedOption === "") {
                        // Allow empty input and clear the value
                        setBloodPressure((prev) => ({
                            ...prev,
                            [fieldToUpdate]: "",
                        }));
                        return;
                    }
                
                    // Check if the input is "0", "3", "00", or "30"
                    if (validatedOption === "0" || validatedOption === "3" || validatedOption === "00" || validatedOption === "30") {
                        // Update the state with the validated option
                        setBloodPressure((prev) => ({
                            ...prev,
                            [fieldToUpdate]: validatedOption,
                        }));
                        return;
                    }
                }


            }
            else if (fieldToUpdate === "frequencyBP") {
                if (option.length <= 3 && /^[0-9]+$|^$/.test(option)) {
                    setBloodPressure((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "lower_Threshold_systolicBP" || fieldToUpdate === "upper_Threshold_systolicBP" || id === 'lower_Threshold_DiastolicBP' || id === 'upper_Threshold_DiastolicBP') {
                // Regular expression to match the desired format
                const validInputRegex = /^\d{0,3}?$/;
                if (validInputRegex.test(option)) {
                    setBloodPressure((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "isAMorPMBP") {
                let amOrpm = option === 'AM' ? 'PM' : 'AM'

                // Regular expression to match the desired format
                setBloodPressure((prev) => ({
                    ...prev,
                    [fieldToUpdate]: amOrpm
                }))

            }

            else {
                setBloodPressure((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }

        }
    }
    function handleOnChangeSPO2(id, option) {
        setSubmitSelected(false)
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false);

        const fieldToUpdate = {
            startTimeMoniHourSPO2: 'startTimeMoniHourSPO2',
            startTimeMoniMinuteSPO2: 'startTimeMoniMinuteSPO2',
            frequencySPO2: 'frequencySPO2',
            time_periodSPO2: 'time_periodSPO2',
            maximumTimeDelayHourSPO2: 'maximumTimeDelayHourSPO2',
            maximumTimeDelayMinuteSPO2: 'maximumTimeDelayMinuteSPO2',
            lower_ThresholdSPO2: 'lower_ThresholdSPO2',
            isAMorPMSPO2: 'isAMorPMSPO2'
        }[id];

        if (fieldToUpdate) {
            if (fieldToUpdate === "startTimeMoniHourSPO2" || fieldToUpdate === "startTimeMoniMinuteSPO2" || fieldToUpdate === 'maximumTimeDelayHourSPO2' || fieldToUpdate === 'maximumTimeDelayMinuteSPO2') {
                if ((fieldToUpdate === "startTimeMoniHourSPO2" || fieldToUpdate === "maximumTimeDelayHourSPO2")) {
                    //^(?:[0-9]|1[0-2])$
                    const validInputRegex = /^(0?[1-9]|1[0-2]|0)$|^$/;
                    if (validInputRegex.test(option)) {
                        setSpo2((prev) => ({
                            ...prev,
                            [fieldToUpdate]: option,
                        }));
                    }


                }
                if ((fieldToUpdate === "startTimeMoniMinuteSPO2" || fieldToUpdate === "maximumTimeDelayMinuteSPO2")) {
                    let validatedOption = option.trim(); // Remove leading and trailing spaces
                    // Check if the input is empty
                    if (validatedOption === "") {
                        // Allow empty input and clear the value
                        setSpo2((prev) => ({
                            ...prev,
                            [fieldToUpdate]: "",
                        }));
                        return;
                    }
                
                    // Check if the input is "0", "3", "00", or "30"
                    if (validatedOption === "0" || validatedOption === "3" || validatedOption === "00" || validatedOption === "30") {
                        // Update the state with the validated option
                        setSpo2((prev) => ({
                            ...prev,
                            [fieldToUpdate]: validatedOption,
                        }));
                        return;
                    }
                }


            }
            else if (fieldToUpdate === "frequencySPO2") {
                if (option.length <= 3 && /^[0-9]+$|^$/.test(option)) {
                    setSpo2((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "lower_ThresholdSPO2") {
                // Regular expression to match the desired format
                const validInputRegex = /^(100(\.00?)?|\d{0,2}(\.\d{0,2})?)%?$/;
                if (validInputRegex.test(option)) {
                    setSpo2((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "isAMorPMSPO2") {
                let amOrpm = option === 'AM' ? 'PM' : 'AM'

                // Regular expression to match the desired format
                setSpo2((prev) => ({
                    ...prev,
                    [fieldToUpdate]: amOrpm
                }))

            }

            else {
                setSpo2((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }

        }
    }
    function handleOnChangePulse(id, option) {
        setSubmitSelected(false)
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false);

        const fieldToUpdate = {
            startTimeMoniHourPulse: 'startTimeMoniHourPulse',
            startTimeMoniMinutePulse: 'startTimeMoniMinutePulse',
            frequencyPulse: 'frequencyPulse',
            time_periodPulse: 'time_periodPulse',
            maximumTimeDelayHourPulse: 'maximumTimeDelayHourPulse',
            maximumTimeDelayMinutePulse: 'maximumTimeDelayMinutePulse',
            lower_ThresholdPulse: 'lower_ThresholdPulse',
            upper_ThresholdPulse: 'upper_ThresholdPulse',
            isAMorPMPulse: 'isAMorPMPulse'
        }[id];


        if (fieldToUpdate) {
            if (fieldToUpdate === "startTimeMoniHourPulse" || fieldToUpdate === "startTimeMoniMinutePulse" || fieldToUpdate === 'maximumTimeDelayHourPulse' || fieldToUpdate === 'maximumTimeDelayMinutePulse') {

                if ((fieldToUpdate === "startTimeMoniHourPulse" || fieldToUpdate === "maximumTimeDelayHourPulse")) {
                    //^(?:[0-9]|1[0-2])$
                    const validInputRegex = /^(0?[1-9]|1[0-2]|0)$|^$/;
                    if (validInputRegex.test(option)) {
                        setPulse((prev) => ({
                            ...prev,
                            [fieldToUpdate]: option,
                        }));
                    }


                }
                if ((fieldToUpdate === "startTimeMoniMinutePulse" || fieldToUpdate === "maximumTimeDelayMinutePulse")) {
                    let validatedOption = option.trim(); // Remove leading and trailing spaces
                    // Check if the input is empty
                    if (validatedOption === "") {
                        // Allow empty input and clear the value
                        setPulse((prev) => ({
                            ...prev,
                            [fieldToUpdate]: "",
                        }));
                        return;
                    }
                
                    // Check if the input is "0", "3", "00", or "30"
                    if (validatedOption === "0" || validatedOption === "3" || validatedOption === "00" || validatedOption === "30") {
                        // Update the state with the validated option
                        setPulse((prev) => ({
                            ...prev,
                            [fieldToUpdate]: validatedOption,
                        }));
                        return;
                    }
                }

            }
            else if (fieldToUpdate === "frequencyPulse") {
                if (option.length <= 3 && /^[0-9]+$|^$/.test(option)) {
                    setPulse((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "lower_ThresholdPulse" || fieldToUpdate === "upper_ThresholdPulse") {
                // Regular expression to match the desired format
                const validInputRegex = /^\d{0,3}?$/;
                if (validInputRegex.test(option)) {
                    setPulse((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "isAMorPMPulse") {
                let amOrpm = option === 'AM' ? 'PM' : 'AM'

                // Regular expression to match the desired format
                setPulse((prev) => ({
                    ...prev,
                    [fieldToUpdate]: amOrpm
                }))

            }

            else {
                setPulse((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }

        }
    }
    function handleOnChangeTemp(id, option) {
        setSubmitSelected(false)
        setIsAnyFieldFilled!==undefined&& setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false);

        const fieldToUpdate = {
            startTimeMoniHourTemp: 'startTimeMoniHourTemp',
            startTimeMoniMinuteTemp: 'startTimeMoniMinuteTemp',
            frequencyTemp: 'frequencyTemp',
            time_periodTemp: 'time_periodTemp',
            maximumTimeDelayHourTemp: 'maximumTimeDelayHourTemp',
            maximumTimeDelayMinuteTemp: 'maximumTimeDelayMinuteTemp',
            upper_ThresholdTemp: 'upper_ThresholdTemp',
            isAMorPMTemp: 'isAMorPMTemp'
        }[id];


        if (fieldToUpdate) {
            if (fieldToUpdate === "startTimeMoniHourTemp" || fieldToUpdate === "startTimeMoniMinuteTemp" || fieldToUpdate === "maximumTimeDelayHourTemp" || fieldToUpdate === "maximumTimeDelayMinuteTemp") {
                if ((fieldToUpdate === "startTimeMoniHourTemp" || fieldToUpdate === "maximumTimeDelayHourTemp")) {
                    //^(?:[0-9]|1[0-2])$
                    const validInputRegex = /^(0?[1-9]|1[0-2]|0)$|^$/;
                    if (validInputRegex.test(option)) {
                        setTemprature((prev) => ({
                            ...prev,
                            [fieldToUpdate]: option,
                        }));
                    }


                }
                if ((fieldToUpdate === "startTimeMoniMinuteTemp" || fieldToUpdate === "maximumTimeDelayMinuteTemp")) {
                    let validatedOption = option.trim(); // Remove leading and trailing spaces
                    // Check if the input is empty
                    if (validatedOption === "") {
                        // Allow empty input and clear the value
                        setTemprature((prev) => ({
                            ...prev,
                            [fieldToUpdate]: "",
                        }));
                        return;
                    }
                
                    // Check if the input is "0", "3", "00", or "30"
                    if (validatedOption === "0" || validatedOption === "3" || validatedOption === "00" || validatedOption === "30") {
                        // Update the state with the validated option
                        setTemprature((prev) => ({
                            ...prev,
                            [fieldToUpdate]: validatedOption,
                        }));
                        return;
                    }
                }
            }
            else if (fieldToUpdate === "frequencyTemp") {
                if (option.length <= 3 && /^[0-9]+$|^$/.test(option)) {
                    setTemprature((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "upper_ThresholdTemp") {
                // Regular expression to match the desired format
                const validInputRegex = /^(?=(?:\D*\d){0,5}\D*$)\d*(?:\.\d*)?$/;

                if (validInputRegex.test(option)) {
                    setTemprature((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }


            }
            else if (fieldToUpdate === "isAMorPMTemp") {
                let amOrpm = option === 'AM' ? 'PM' : 'AM'

                // Regular expression to match the desired format
                setTemprature((prev) => ({
                    ...prev,
                    [fieldToUpdate]: amOrpm
                }))

            }

            else {
                setTemprature((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }

        }
    }
    function handleOnChangeWeight(id, option) {
        setSubmitSelected(false)
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false);

        const fieldToUpdate = {
            startTimeMoniHourWeight: 'startTimeMoniHourWeight',
            startTimeMoniMinuteWeight: 'startTimeMoniMinuteWeight',
            frequencyWeight: 'frequencyWeight',
            time_periodWeight: 'time_periodWeight',
            maximumTimeDelayHourWeight: 'maximumTimeDelayHourWeight',
            maximumTimeDelayMinuteWeight: 'maximumTimeDelayMinuteWeight',
            lower_ThresholdWeight: 'lower_ThresholdWeight',
            upper_ThresholdWeight: 'upper_ThresholdWeight',
            isAMorPMWeight: 'isAMorPMWeight'
        }[id];


        if (fieldToUpdate) {
            if (fieldToUpdate === "startTimeMoniHourWeight" || fieldToUpdate === "startTimeMoniMinuteWeight" || fieldToUpdate === "maximumTimeDelayHourWeight" || fieldToUpdate === "maximumTimeDelayMinuteWeight") {
                if ((fieldToUpdate === "startTimeMoniHourWeight" || fieldToUpdate === "maximumTimeDelayHourWeight")) {
                    //^(?:[0-9]|1[0-2])$
                    const validInputRegex = /^(0?[1-9]|1[0-2]|0)$|^$/;
                    if (validInputRegex.test(option)) {
                        setWeight((prev) => ({
                            ...prev,
                            [fieldToUpdate]: option,
                        }));
                    }


                }
                if ((fieldToUpdate === "startTimeMoniMinuteWeight" || fieldToUpdate === "maximumTimeDelayMinuteWeight")) {
                    let validatedOption = option.trim(); // Remove leading and trailing spaces
                    // Check if the input is empty
                    if (validatedOption === "") {
                        // Allow empty input and clear the value
                        setWeight((prev) => ({
                            ...prev,
                            [fieldToUpdate]: "",
                        }));
                        return;
                    }
                
                    // Check if the input is "0", "3", "00", or "30"
                    if (validatedOption === "0" || validatedOption === "3" || validatedOption === "00" || validatedOption === "30") {
                        // Update the state with the validated option
                        setWeight((prev) => ({
                            ...prev,
                            [fieldToUpdate]: validatedOption,
                        }));
                        return;
                    }
                }

            }
            else if (fieldToUpdate === "frequencyWeight") {
                if (option.length <= 3 && /^[0-9]+$|^$/.test(option)) {
                    setWeight((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "lower_ThresholdWeight" || fieldToUpdate === "upper_ThresholdWeight") {
                // Regular expression to match the desired format
                const validInputRegex = /^(?=(?:\D*\d){0,5}\D*$)\d*(?:\.\d*)?$/;

                if (validInputRegex.test(option)) {
                    setWeight((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }


            }
            else if (fieldToUpdate === "isAMorPMWeight") {
                let amOrpm = option === 'AM' ? 'PM' : 'AM'

                // Regular expression to match the desired format
                setWeight((prev) => ({
                    ...prev,
                    [fieldToUpdate]: amOrpm
                }))

            }

            else {
                setWeight((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }

        }
    }
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)

 
    return (
        <>
            {isPatient!==undefined&&<div className='w-full flex justify-end pr-3 2xl:pr-[29px] pb-4'><button type='button'
                id={'choose_template'}
                className={`py-3 px-3  min-w-max flex items-center text-lg font-normal border border-[#972E4C] text-[#972E4C] rounded-[16px] ml-2.5   bg-[#fff]`}
                onClick={() => {setChooseTemplate(true)}}
            >
                <span className="mr-2.5 text-center"><img src="/images/health-insurance.svg" alt="img"/></span>
                Choose Template
            </button></div>  }
            <div className={`${isPatient!==undefined?'height: calc(100vh - 483px)':'h-customh18'} overflow-auto  overflow-x-hidden scrollBar_green pr-3 2xl:pr-[29px]`}>
                {(edit && isPatient===undefined)&&(
                    <div className='flex flex-wrap -mx-3'>
                        <div className='xl:w-1/3 xl:min-w-[33.33%] min-w-[300px] max-w-[220px] px-3 mb-[22px]'>
                            <div className='w-full'>
                                <InputBox
                                    label={"Created By"}
                                    value={data?.created_by}
                                    disabled={edit === true ? true : false}
                                                              
                                />
                            </div>
                        </div>
                        <div className='xl:w-1/3 xl:min-w-[33.33%] min-w-[300px] max-w-[220px] px-3 mb-[22px]'>
                            <div className='w-full'>
                                <InputBox
                                    label={"Last Modified Date"}
                                    value={convertEpochToDateFormat(data?.updated_at,dateformat)}
                                    data_testid={"template_name"}
                                    disabled={edit === true ? true : false}
                                                           
                                />
                            </div>
                        </div>
                    </div>
                )
                }
                <div className='rounded-lg  px-4 py-2 border border-[#CCE7E7] mb-3'>
                    <div className='flex justify-between items-center'>
                        <div className="relative checkbox custom-checkBoxBlue1 flex items-center w-full">
                            <input
                                type="checkbox"
                                id="blood_glouse"
                                data-testid={"Blood Glucose"}
                                className="cursor-pointer"
                                checked={isBGCheckboxChecked}
                                onChange={handleBGCheckboxChange}
                            />
                            <label htmlFor="blood_glouse" className="text-sm font-semibold text-[#008586] cursor-pointer pl-5 w-full">
                                Blood Glucose
                            </label>
                        </div>

                        <span>
                            <img loading='lazy' decoding='async' src="/images/bloodGlucose.svg" alt="img" />
                        </span>
                    </div>
                    {isBGCheckboxChecked && <div className='w-full'>

                        <div className='flex xl:overflow-visible -mx-2 mt-3'>
                            <div className='min-w-[33%] xl:w-[24%] xl:max-w-[24%] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Start Time of Monitoring*"}
                                        htmlFor1={"startTimeMoniHourBG"}
                                        id1={"startTimeMoniHourBG"}
                                        htmlFor2={'startTimeMoniMinuteBG'}
                                        id2={'startTimeMoniMinuteBG'}
                                        id3={'isAMorPM'}
                                        placeholder1={'Hour'}
                                        data_testid1={"start_time_hour"}
                                        data_testid2={"start_time_min"}
                                        placeholder2={'Minute'}

                                        timeFormat={true}
                                        value={bloodGlucose.startTimeMoniHourBG}  // Value for the first input
                                        value2={bloodGlucose.startTimeMoniMinuteBG}  // Value for the second input
                                        value3={bloodGlucose.isAMorPM}
                                        emptyField={isBGCheckboxChecked && emptyField && (bloodGlucose.startTimeMoniHourBG?.trim() === "" || bloodGlucose.startTimeMoniMinuteBG?.trim() === "")}
                                        handleOnChangeInput={handleOnChangeBloodGlouse}
                                    />
                                </div>
                            </div>
                            <div className='min-w-[20%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputBox
                                        label={"Frequency of Monitoring*"}
                                        placeholder={"Enter Frequency"}
                                        id={"frequency"}
                                        data_testid={"frequency_monitor"}
                                        htmlFor={"frequency"}
                                        value={bloodGlucose?.frequency}
                                        emptyField={isBGCheckboxChecked && emptyField && bloodGlucose?.frequency?.trim() === ""}
                                        handleOnChangeInput={handleOnChangeBloodGlouse}
                                    />
                                </div>
                            </div>
                            <div className='xl:w-[4%] w-[37px] xl:max-w-[4%] px-2 mb-[22px] flex justify-center items-center pt-4'>
                                <hr className='w-[2px] bg-[#777C88] h-6 rotate-[25deg] '></hr>
                            </div>
                            <div className='min-w-[19%] max-w-[19%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Time Period*"}
                                        id={"time_period"}
                                        placeholder={'Day(s)'}
                                        data_testid={"time_period"}
                                        value={bloodGlucose?.time_period}
                                        options={['Day(s)', 'Week(s)', 'Month(s)', 'Calendar Month(s)']}
                                        emptyField={""}
                                        handleOnChangeInput={handleOnChangeBloodGlouse}
                                        widthAuto={true}
                                    />
                                </div>
                            </div>
                            <div className='min-w-[21%] xl:w-[22%] xl:max-w-[22%] xl:min-w-[22%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Maximum Time Delay*"}
                                        htmlFor1={"maximumTimeDelayHourBG"}
                                        id1={"maximumTimeDelayHourBG"}
                                        htmlFor2={'maximumTimeDelayMinuteBG'}
                                        id2={'maximumTimeDelayMinuteBG'}
                                        data_testid1={"hour"}
                                        data_testid2={"minutes"}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        maxLength={2}
                                        value={bloodGlucose.maximumTimeDelayHourBG}  // Value for the first input
                                        value2={bloodGlucose.maximumTimeDelayMinuteBG}  //value for 2nd input
                                        handleOnChangeInput={handleOnChangeBloodGlouse}
                                        emptyField={isBGCheckboxChecked && emptyField && (bloodGlucose?.maximumTimeDelayHourBG?.trim() === "" || bloodGlucose.maximumTimeDelayMinuteBG?.trim() === "")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-2 xl:pt-0 pt-1'>
                            <div className='xl:w-[24%] min-w-[200px] max-w-[200px] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Lower Threshold*'>Lower Threshold*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'lower_Threshold'}
                                            htmlFor={"lower_Threshold"}
                                            isUnit={true}
                                            data_testid={"lower_thershold"}
                                            unitType={((edit && bloodGlucose?.unit) || bloodGlucose?.unit !=="" && bloodGlucose?.unit!==undefined )? bloodGlucose?.unit : unittype}
                                            value={bloodGlucose?.lower_Threshold}
                                            emptyField={(isBGCheckboxChecked && emptyField && bloodGlucose.lower_Threshold?.trim() === "") || (submitSelected && (parseInt(bloodGlucose?.lower_Threshold) > parseInt(bloodGlucose?.upper_Threshold)))}
                                            handleOnChangeInput={handleOnChangeBloodGlouse}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='xl:w-1/4 min-w-[210px] max-w-[210px] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Upper Threshold*'>Upper Threshold*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'upper_Threshold'}
                                            htmlFor={"upper_Threshold"}
                                            data_testid={"upper_thershold"}
                                            isUnit={true}
                                            unitType={((edit && bloodGlucose?.unit) || bloodGlucose?.unit !=="" && bloodGlucose?.unit!==undefined)? bloodGlucose?.unit : unittype}
                                            value={bloodGlucose?.upper_Threshold}
                                            emptyField={(isBGCheckboxChecked && emptyField && bloodGlucose?.upper_Threshold.trim() === "") || (submitSelected && (parseInt(bloodGlucose?.lower_Threshold) > parseInt(bloodGlucose?.upper_Threshold)))}
                                            handleOnChangeInput={handleOnChangeBloodGlouse}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                </div>
                <div className='rounded-lg px-4 py-2 border border-[#CCE7E7] mb-3'>
                    <div className='flex justify-between items-center'>
                        <div className="relative checkbox custom-checkBoxBlue1 flex items-center w-full">
                            <input
                                type="checkbox"
                                id="blood_pressure"
                                data-testid={"Blood Pressure"}
                                className="cursor-pointer"
                                checked={isBPCheckboxChecked}
                                onChange={handleBPCheckboxChange}
                            />
                            <label htmlFor="blood_pressure" className="text-sm font-semibold text-[#008586] cursor-pointer pl-5 w-full">
                                Blood Pressure
                            </label>
                        </div>

                        <span>
                            <img loading='lazy' decoding='async' src="/images/bloodpressure.svg" alt="img" />
                        </span>
                    </div>
                    {isBPCheckboxChecked && <div className='w-full'>
                        <div className='flex xl:overflow-visible -mx-2 mt-3'>
                            <div className='min-w-[33%] xl:w-[24%] xl:max-w-[24%] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Start Time of Monitoring*"}
                                        htmlFor1={"startTimeMoniHourBp"}
                                        id1={"startTimeMoniHourBP"}
                                        htmlFor2={'startTimeMoniMinuteBP'}
                                        id2={'startTimeMoniMinuteBP'}
                                        id3={'isAMorPMBP'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        timeFormat={true}
                                        value={bloodPressure?.startTimeMoniHourBP}  // Value for the first input
                                        value2={bloodPressure?.startTimeMoniMinuteBP}  // Value for the second input
                                        value3={bloodPressure?.isAMorPMBP}
                                        emptyField={isBPCheckboxChecked && emptyField && (bloodPressure?.startTimeMoniHourBP?.trim() === "" || bloodPressure.startTimeMoniMinuteBP?.trim() === "")}
                                        handleOnChangeInput={handleOnChangeBloodPressure}
                                    />
                                </div>
                            </div>
                            <div className='min-w-[20%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputBox
                                        label={"Frequency of Monitoring*"}
                                        placeholder={"Enter Frequency"}
                                        id={"frequencyBP"}
                                        htmlFor={"frequencyBP"}
                                        value={bloodPressure?.frequencyBP}
                                        emptyField={isBPCheckboxChecked && emptyField && bloodPressure?.frequencyBP?.trim() === ""}
                                        handleOnChangeInput={handleOnChangeBloodPressure}
                                    />
                                </div>
                            </div>
                            <div className='xl:w-[4%] w-[37px] xl:max-w-[4%] px-2 mb-[22px] flex justify-center items-center pt-4'>
                                <hr className='w-[2px] bg-[#777C88] h-6 rotate-[25deg] '></hr>
                            </div>
                            <div className='min-w-[19%] max-w-[19%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Time Period*"}
                                        id={"time_periodBP"}
                                        placeholder={'Day(s)'}
                                        value={bloodPressure?.time_periodBP}
                                        options={['Day(s)', 'Week(s)', 'Month(s)', 'Calendar Month(s)']}
                                        emptyField={""}
                                        handleOnChangeInput={handleOnChangeBloodPressure}
                                    />
                                </div>
                            </div>
                            <div className='min-w-[21%] xl:w-[22%] xl:max-w-[22%] xl:min-w-[22%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Maximum Time Delay*"}
                                        htmlFor1={"maximumTimeDelayHourBP"}
                                        id1={"maximumTimeDelayHourBP"}
                                        htmlFor2={'maximumTimeDelayMinuteBP'}
                                        id2={'maximumTimeDelayMinuteBP'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        value={bloodPressure?.maximumTimeDelayHourBP}  // Value for the first input
                                        value2={bloodPressure?.maximumTimeDelayMinuteBP}
                                        handleOnChangeInput={handleOnChangeBloodPressure}
                                        emptyField={isBPCheckboxChecked && emptyField && (bloodPressure?.maximumTimeDelayHourBP?.trim() === "" || bloodPressure?.maximumTimeDelayMinuteBP?.trim() === "")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-2 xl:pt-0 pt-1'>
                            <div className='xl:w-[24%] min-w-[200px] max-w-[200px] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Lower Threshold for Systolic*'>Lower Threshold for Systolic*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'lower_Threshold_systolicBP'}
                                            htmlFor={"lower_Threshold_systolicBP"}
                                            isUnit={true}
                                            unitType={((edit && bloodPressure?.unit) || bloodPressure?.unit!=="" && bloodPressure?.unit!==undefined) ? bloodPressure?.unit : unittype1}
                                            value={bloodPressure?.lower_Threshold_systolicBP}
                                            emptyField={(isBPCheckboxChecked && emptyField && bloodPressure.lower_Threshold_systolicBP?.trim() === "") ||  (submitSelected && (parseInt(bloodPressure?.lower_Threshold_systolicBP) > parseInt(bloodPressure?.upper_Threshold_systolicBP)))}
                                            handleOnChangeInput={handleOnChangeBloodPressure}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='xl:w-1/4 min-w-[210px] max-w-[210px] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title="Upper Threshold for Systolic*">Upper Threshold for Systolic*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'upper_Threshold_systolicBP'}
                                            htmlFor={"upper_Threshold_systolicBP"}
                                            isUnit={true}
                                            unitType={((edit && bloodPressure?.unit) || bloodPressure?.unit!=="" && bloodPressure?.unit!==undefined) ? bloodPressure?.unit : unittype1}
                                            value={bloodPressure?.upper_Threshold_systolicBP}
                                            emptyField={(isBPCheckboxChecked && emptyField && bloodPressure?.upper_Threshold_systolicBP.trim() === "") || (submitSelected && (parseInt(bloodPressure?.lower_Threshold_systolicBP) > parseInt(bloodPressure?.upper_Threshold_systolicBP)))}
                                            handleOnChangeInput={handleOnChangeBloodPressure}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-2 mt-3'>
                            <div className='xl:w-[24%] min-w-[200px] max-w-[200px] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Lower Threshold for Diastolic*'>Lower Threshold for Diastolic*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'lower_Threshold_DiastolicBP'}
                                            htmlFor={"lower_Threshold_DiastolicBP"}
                                            isUnit={true}
                                            unitType={((edit && bloodPressure?.unit) || bloodPressure?.unit!=="" && bloodPressure?.unit!==undefined) ? bloodPressure?.unit : unittype1}
                                            value={bloodPressure?.lower_Threshold_DiastolicBP}
                                            emptyField={(isBPCheckboxChecked && emptyField && bloodPressure?.lower_Threshold_DiastolicBP?.trim() === "") || (submitSelected && (parseInt(bloodPressure?.lower_Threshold_DiastolicBP) > parseInt(bloodPressure?.upper_Threshold_DiastolicBP)))}
                                            handleOnChangeInput={handleOnChangeBloodPressure}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='xl:w-1/4 min-w-[210px] max-w-[210px] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Upper Threshold for Diastolic*'>Upper Threshold for Diastolic*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'upper_Threshold_DiastolicBP'}
                                            htmlFor={"upper_Threshold_DiastolicBP"}
                                            isUnit={true}
                                            unitType={((edit && bloodPressure?.unit) || bloodPressure?.unit!=="" && bloodPressure?.unit!==undefined) ? bloodPressure?.unit : unittype1}
                                            value={bloodPressure?.upper_Threshold_DiastolicBP}
                                            emptyField={(isBPCheckboxChecked && emptyField && bloodPressure?.upper_Threshold_DiastolicBP.trim() === "") || (submitSelected && (parseInt(bloodPressure?.lower_Threshold_DiastolicBP) > parseInt(bloodPressure?.upper_Threshold_DiastolicBP)))}
                                            handleOnChangeInput={handleOnChangeBloodPressure}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                <div className='rounded-lg px-4 py-2 border border-[#CCE7E7] mb-3'>
                    <div className='flex justify-between items-center'>
                        <div className="relative checkbox custom-checkBoxBlue1 flex items-center w-full">
                            <input
                                type="checkbox"
                                id="SPO2"
                                data-testid={"SPO2"}
                                className="cursor-pointer"
                                checked={isSPO2CheckboxChecked}
                                onChange={handleSPO2CheckboxChange}
                            />
                            <label htmlFor="SPO2" className="text-sm font-semibold text-[#008586] cursor-pointer pl-5 w-full">
                                SPO2
                            </label>
                        </div>

                        <span>
                            <img loading='lazy' decoding='async' src="/images/spo2.svg" alt="img" />
                        </span>
                    </div>
                    {isSPO2CheckboxChecked && <div className='w-full'>
                        <div className='flex xl:overflow-visible -mx-2 mt-3'>
                            <div className='min-w-[33%] xl:w-[24%] xl:max-w-[24%] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Start Time of Monitoring*"}
                                        htmlFor1={"startTimeMoniHourSPO2"}
                                        id1={"startTimeMoniHourSPO2"}
                                        htmlFor2={'startTimeMoniMinuteSPO2'}
                                        id2={'startTimeMoniMinuteSPO2'}
                                        id3={'isAMorPMSPO2'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}

                                        timeFormat={true}
                                        value={spo2?.startTimeMoniHourSPO2}  // Value for the first input
                                        value2={spo2?.startTimeMoniMinuteSPO2}  // Value for the second input
                                        value3={spo2?.isAMorPMSPO2}
                                        emptyField={isSPO2CheckboxChecked && emptyField && (spo2.startTimeMoniHourSPO2?.trim() === "" || spo2.startTimeMoniMinuteSPO2?.trim() === "")}
                                        handleOnChangeInput={handleOnChangeSPO2}
                                    />
                                </div>

                            </div>
                            <div className='min-w-[20%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputBox
                                        label={"Frequency of Monitoring*"}
                                        placeholder={"Enter Frequency"}
                                        id={"frequencySPO2"}
                                        htmlFor={"frequencySPO2"}
                                        value={spo2?.frequencySPO2}
                                        emptyField={isSPO2CheckboxChecked && emptyField && spo2?.frequencySPO2?.trim() === ""}
                                        handleOnChangeInput={handleOnChangeSPO2}
                                    />
                                </div>
                            </div>
                            <div className='xl:w-[4%] w-[37px] xl:max-w-[4%] px-2 mb-[22px] flex justify-center items-center pt-4'>
                                <hr className='w-[2px] bg-[#777C88] h-6 rotate-[25deg] '></hr>
                            </div>
                            <div className='min-w-[19%] max-w-[19%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Time Period*"}
                                        id={"time_periodSPO2"}
                                        placeholder={'Day(s)'}
                                        value={spo2.time_periodSPO2}
                                        options={['Day(s)', 'Week(s)', 'Month(s)', 'Calendar Month(s)']}
                                        emptyField={""}
                                        handleOnChangeInput={handleOnChangeSPO2}
                                    />
                                </div>
                            </div>
                            <div className='min-w-[21%] xl:w-[22%] xl:max-w-[22%] xl:min-w-[22%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Maximum Time Delay*"}
                                        htmlFor1={"maximumTimeDelayHourSPO2"}
                                        id1={"maximumTimeDelayHourSPO2"}
                                        htmlFor2={'maximumTimeDelayMinuteSPO2'}
                                        id2={'maximumTimeDelayMinuteSPO2'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        value={spo2.maximumTimeDelayHourSPO2}  // Value for the first input
                                        value2={spo2.maximumTimeDelayMinuteSPO2}
                                        handleOnChangeInput={handleOnChangeSPO2}
                                        emptyField={isSPO2CheckboxChecked && emptyField && (spo2?.maximumTimeDelayHourSPO2?.trim() === "" || spo2.maximumTimeDelayMinuteSPO2?.trim() === "")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-2 xl:pt-0 pt-1'>
                            <div className='xl:w-[24%] min-w-[200px] max-w-[200px] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Lower Threshold*'>Lower Threshold*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'lower_ThresholdSPO2'}
                                            htmlFor={"lower_ThresholdSPO2"}
                                            isUnit={true}
                                            unitType={((edit && spo2?.unit) || spo2?.unit!=="" && spo2.unit!==undefined)? spo2?.unit : unittype3}
                                            value={spo2?.lower_ThresholdSPO2}
                                            emptyField={isSPO2CheckboxChecked && emptyField && spo2.lower_ThresholdSPO2?.trim() === ""}
                                            handleOnChangeInput={handleOnChangeSPO2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                </div>
                <div className='rounded-lg px-4 py-2 border border-[#CCE7E7] mb-3'>
                    <div className='flex justify-between items-center'>
                        <div className="relative checkbox custom-checkBoxBlue1 flex items-center w-full">
                            <input
                                type="checkbox"
                                id="pulse"
                                data-testid={"Pulse"}
                                className="cursor-pointer"
                                checked={isPulseCheckboxChecked}
                                onChange={handlePulseCheckboxChange}
                            />
                            <label htmlFor="pulse" className="text-sm font-semibold text-[#008586] cursor-pointer pl-5 w-full">
                                Pulse
                            </label>
                        </div>

                        <span>
                            <img loading='lazy' decoding='async' src="/images/pulse.svg" alt="img" />
                        </span>
                    </div>
                    {isPulseCheckboxChecked && <div className='w-full'>
                        <div className='flex xl:overflow-visible -mx-2 mt-3'>
                            <div className='min-w-[33%] xl:w-[24%] xl:max-w-[24%] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Start Time of Monitoring*"}
                                        htmlFor1={"startTimeMoniHourPulse"}
                                        id1={"startTimeMoniHourPulse"}
                                        htmlFor2={'startTimeMoniMinutePulse'}
                                        id2={'startTimeMoniMinutePulse'}
                                        id3={'isAMorPMPulse'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        data_testid1={"start_time_hour"}
                                        data_testid2={"start_time_min"}
                                        timeFormat={true}
                                        value={pulse?.startTimeMoniHourPulse}  // Value for the first input
                                        value2={pulse?.startTimeMoniMinutePulse}  // Value for the second input
                                        value3={pulse?.isAMorPMPulse}
                                        emptyField={isPulseCheckboxChecked && emptyField && (pulse.startTimeMoniHourPulse?.trim() === "" || pulse.startTimeMoniMinutePulse?.trim() === "")}
                                        handleOnChangeInput={handleOnChangePulse}
                                    />
                                </div>

                            </div>
                            <div className='min-w-[20%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputBox
                                        label={"Frequency of Monitoring*"}
                                        placeholder={"Enter Frequency"}
                                        id={"frequencyPulse"}
                                        data_testid={"frequency_monitor"}
                                        htmlFor={"frequencyPulse"}
                                        value={pulse?.frequencyPulse}
                                        emptyField={isPulseCheckboxChecked && emptyField && pulse?.frequencyPulse?.trim() === ""}
                                        handleOnChangeInput={handleOnChangePulse}
                                    />
                                </div>
                            </div>
                            <div className='xl:w-[4%] w-[37px] xl:max-w-[4%] px-2 mb-[22px] flex justify-center items-center pt-4'>
                                <hr className='w-[2px] bg-[#777C88] h-6 rotate-[25deg] '></hr>
                            </div>
                            <div className='min-w-[19%] max-w-[19%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Time Period*"}
                                        id={"time_periodPulse"}
                                        placeholder={'Day(s)'}
                                        data_testid={"time_period"}
                                        value={pulse.time_periodPulse}
                                        options={['Day(s)', 'Week(s)', 'Month(s)', 'Calendar Month(s)']}
                                        emptyField={""}
                                        handleOnChangeInput={handleOnChangePulse}
                                    />
                                </div>
                            </div>
                            <div className='min-w-[21%] xl:w-[22%] xl:max-w-[22%] xl:min-w-[22%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Maximum Time Delay*"}
                                        htmlFor1={"maximumTimeDelayHourPulse"}
                                        id1={"maximumTimeDelayHourPulse"}
                                        htmlFor2={'maximumTimeDelayMinutePulse'}
                                        id2={'maximumTimeDelayMinutePulse'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        data_testid1={"hour"}
                                        data_testid2={"minutes"}
                                        value={pulse.maximumTimeDelayHourPulse}  // Value for the first input
                                        value2={pulse.maximumTimeDelayMinutePulse}
                                        handleOnChangeInput={handleOnChangePulse}
                                        emptyField={isPulseCheckboxChecked && emptyField && (pulse?.maximumTimeDelayHourPulse?.trim() === "" || pulse.maximumTimeDelayMinutePulse?.trim() === "")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-2 xl:pt-0 pt-1'>
                            <div className='xl:w-[24%] min-w-[200px] max-w-[200px] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Lower Threshold*'>Lower Threshold*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'lower_ThresholdPulse'}
                                            htmlFor={"lower_ThresholdPulse"}
                                            isUnit={true}
                                            data_testid={"lower_thershold"}
                                            unitType={((edit&&pulse?.unit) || pulse?.unit!=="" && pulse?.unit!==undefined)? pulse?.unit : unittype4}
                                            value={pulse?.lower_ThresholdPulse}
                                            emptyField={(isPulseCheckboxChecked && emptyField && pulse?.lower_ThresholdPulse?.trim() === "") || (submitSelected && (parseInt(pulse?.lower_ThresholdPulse) > parseInt(pulse?.upper_ThresholdPulse)))}
                                            handleOnChangeInput={handleOnChangePulse}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='xl:w-1/4 min-w-[210px] max-w-[210px] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Upper Threshold*'>Upper Threshold*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'upper_ThresholdPulse'}
                                            htmlFor={"upper_ThresholdPulse"}
                                            isUnit={true}
                                            data_testid={"upper_thershold"}
                                            unitType={((edit&&pulse?.unit) || pulse?.unit!=="" && pulse?.unit!==undefined)? pulse?.unit : unittype4}
                                            value={pulse?.upper_ThresholdPulse}
                                            emptyField={(isPulseCheckboxChecked && emptyField && pulse?.upper_ThresholdPulse.trim() === "") || (submitSelected && (parseInt(pulse?.lower_ThresholdPulse) > parseInt(pulse?.upper_ThresholdPulse)))}
                                            handleOnChangeInput={handleOnChangePulse}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                </div>
                <div className='rounded-lg px-4 py-2 border border-[#CCE7E7] mb-3'>
                    <div className='flex justify-between items-center'>
                        <div className="relative checkbox custom-checkBoxBlue1 flex items-center w-full">
                            <input
                                type="checkbox"
                                id="temprature"
                                data-testid={"Temperature"}
                                className="cursor-pointer"
                                checked={isTempCheckboxChecked}
                                onChange={handleTempCheckboxChange}
                            />
                            <label htmlFor="temprature" className="text-sm font-semibold text-[#008586] cursor-pointer pl-5 w-full">
                                Temperature
                            </label>
                        </div>

                        <span>
                            <img loading='lazy' decoding='async' src="/images/temprature.svg" alt="img" />
                        </span>
                    </div>
                    {isTempCheckboxChecked && <div className='w-full'>
                        <div className='flex xl:overflow-visible -mx-2 mt-3'>
                            <div className='min-w-[33%] xl:w-[24%] xl:max-w-[24%] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Start Time of Monitoring*"}
                                        htmlFor1={"startTimeMoniHourTemp"}
                                        id1={"startTimeMoniHourTemp"}
                                        htmlFor2={'startTimeMoniMinuteTemp'}
                                        id2={'startTimeMoniMinuteTemp'}
                                        id3={'isAMorPMTemp'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        timeFormat={true}
                                        value={temprature.startTimeMoniHourTemp}  // Value for the first input
                                        value2={temprature.startTimeMoniMinuteTemp}  // Value for the second input
                                        value3={temprature.isAMorPMTemp}
                                        emptyField={isTempCheckboxChecked && emptyField && (temprature.startTimeMoniHourTemp?.trim() === "" || temprature.startTimeMoniMinuteTemp?.trim() === "")}
                                        handleOnChangeInput={handleOnChangeTemp}
                                    />
                                </div>

                            </div>
                            <div className='min-w-[20%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputBox
                                        label={"Frequency of Monitoring*"}
                                        placeholder={"Enter Frequency"}
                                        id={"frequencyTemp"}
                                        htmlFor={"frequencyTemp"}
                                        value={temprature?.frequencyTemp}
                                        emptyField={isTempCheckboxChecked && emptyField && temprature?.frequencyTemp?.trim() === ""}
                                        handleOnChangeInput={handleOnChangeTemp}
                                    />
                                </div>
                            </div>
                            <div className='xl:w-[4%] w-[37px] xl:max-w-[4%] px-2 mb-[22px] flex justify-center items-center pt-4'>
                                <hr className='w-[2px] bg-[#777C88] h-6 rotate-[25deg] '></hr>
                            </div>
                            <div className='min-w-[19%] max-w-[19%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Time Period*"}
                                        id={"time_periodTemp"}

                                        placeholder={'Day(s)'}
                                        value={temprature?.time_periodTemp}
                                        options={['Day(s)', 'Week(s)', 'Month(s)', 'Calendar Month(s)']}
                                        emptyField={""}
                                        handleOnChangeInput={handleOnChangeTemp}
                                    />
                                </div>
                            </div>
                            <div className='min-w-[21%] xl:w-[22%] xl:max-w-[22%] xl:min-w-[22%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Maximum Time Delay*"}
                                        htmlFor1={"maximumTimeDelayHourTemp"}
                                        id1={"maximumTimeDelayHourTemp"}
                                        htmlFor2={'maximumTimeDelayMinuteTemp'}
                                        id2={'maximumTimeDelayMinuteTemp'}

                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        value={temprature.maximumTimeDelayHourTemp}  // Value for the first input
                                        value2={temprature.maximumTimeDelayMinuteTemp}
                                        handleOnChangeInput={handleOnChangeTemp}
                                        emptyField={isTempCheckboxChecked && emptyField && (temprature?.maximumTimeDelayHourTemp?.trim() === "" || temprature.maximumTimeDelayMinuteTemp?.trim() === "")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-2 xl:pt-0 pt-1'>
                            <div className='xl:w-[24%] min-w-[200px] max-w-[200px] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Upper Threshold*'>Upper Threshold*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'upper_ThresholdTemp'}
                                            htmlFor={"upper_ThresholdTemp"}
                                            isUnit={true}
                                            unitType={((edit&&temprature?.unit) || temprature?.unit!=="" && temprature.unit!==undefined)? `°${temprature?.unit}` : `°${unittype2}`}
                                            value={temprature?.upper_ThresholdTemp}
                                            emptyField={isTempCheckboxChecked && emptyField && temprature?.upper_ThresholdTemp.trim() === ""}
                                            handleOnChangeInput={handleOnChangeTemp}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                </div>
                <div className='rounded-lg px-4 py-2 border border-[#CCE7E7] mb-3'>
                    <div className='flex justify-between items-center'>
                        <div className="relative checkbox custom-checkBoxBlue1 flex items-center w-full">
                            <input
                                type="checkbox"
                                id="weight"
                                data-testid={"Weight"}
                                className="cursor-pointer"
                                checked={isWeightCheckboxChecked}
                                onChange={handleWeightCheckboxChange}
                            />
                            <label htmlFor="weight" className="text-sm font-semibold text-[#008586] cursor-pointer pl-5 w-full">
                                Weight
                            </label>
                        </div>
                        <span>
                            <img loading='lazy' decoding='async' src="/images/weightScale.svg" alt="img" />
                        </span>
                    </div>
                    {isWeightCheckboxChecked && <div className='w-full'>
                        <div className='flex xl:overflow-visible -mx-2 mt-3'>
                            <div className='min-w-[33%] xl:w-[24%] xl:max-w-[24%] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Start Time of Monitoring*"}
                                        htmlFor1={"startTimeMoniHourWeight"}
                                        id1={"startTimeMoniHourWeight"}
                                        htmlFor2={'startTimeMoniMinuteWeight'}
                                        id2={'startTimeMoniMinuteWeight'}
                                        id3={'isAMorPMWeight'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        timeFormat={true}
                                        value={weight?.startTimeMoniHourWeight}  // Value for the first input
                                        value2={weight?.startTimeMoniMinuteWeight}  // Value for the second input
                                        value3={weight?.isAMorPMWeight}
                                        emptyField={isWeightCheckboxChecked && emptyField && (weight?.startTimeMoniHourWeight?.trim() === "" || weight?.startTimeMoniMinuteWeight?.trim() === "")}
                                        handleOnChangeInput={handleOnChangeWeight}
                                    />
                                </div>

                            </div>
                            <div className='min-w-[20%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputBox
                                        label={"Frequency of Monitoring*"}
                                        placeholder={"Enter Frequency"}
                                        id={"frequencyWeight"}
                                        htmlFor={"frequencyWeight"}
                                        value={weight?.frequencyWeight}
                                        emptyField={isWeightCheckboxChecked && emptyField && weight?.frequencyWeight?.trim() === ""}
                                        handleOnChangeInput={handleOnChangeWeight}
                                    />
                                </div>
                            </div>
                            <div className='xl:w-[4%] w-[37px] xl:max-w-[4%] px-2 mb-[22px] flex justify-center items-center pt-4'>
                                <hr className='w-[2px] bg-[#777C88] h-6 rotate-[25deg] '></hr>
                            </div>
                            <div className='min-w-[19%] max-w-[19%] xl:w-1/4 xl:max-w-[25%] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Time Period*"}
                                        id={"time_periodWeight"}
                                        placeholder={'Day(s)'}
                                        value={weight?.time_periodWeight}
                                        options={['Day(s)', 'Week(s)', 'Month(s)', 'Calendar Month(s)']}
                                        emptyField={""}
                                        handleOnChangeInput={handleOnChangeWeight}
                                    />
                                </div>
                            </div>
                            <div className='min-w-[21%] xl:w-[22%] xl:max-w-[22%] xl:min-w-[22%] px-2 mb-[22px]'>
                                <div className='w-full'>
                                    <InputTimer
                                        mainlabel={"Maximum Time Delay*"}
                                        htmlFor1={"maximumTimeDelayHourWeight"}
                                        id1={"maximumTimeDelayHourWeight"}
                                        htmlFor2={'maximumTimeDelayMinuteWeight'}
                                        id2={'maximumTimeDelayMinuteWeight'}
                                        placeholder1={'Hour'}
                                        placeholder2={'Minute'}
                                        value={weight?.maximumTimeDelayHourWeight}  // Value for the first input
                                        value2={weight?.maximumTimeDelayMinuteWeight}
                                        handleOnChangeInput={handleOnChangeWeight}
                                        emptyField={isWeightCheckboxChecked && emptyField && (weight?.maximumTimeDelayHourWeight?.trim() === "" || weight?.maximumTimeDelayMinuteWeight?.trim() === "")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-2 xl:pt-0 pt-1'>
                            <div className='xl:w-[24%] min-w-[200px] max-w-[200px] xl:min-w-[24%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Lower Threshold*'>Lower Threshold*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'lower_ThresholdWeight'}
                                            htmlFor={"lower_ThresholdWeight"}
                                            isUnit={true}
                                            unitType={((edit&&weight?.unit)|| weight?.unit!=="" && weight.unit!==undefined)? weight?.unit : unittype5}
                                            value={weight?.lower_ThresholdWeight}
                                            emptyField={(isWeightCheckboxChecked && emptyField && weight?.lower_ThresholdWeight?.trim() === "") || (submitSelected && (parseInt(weight?.lower_ThresholdWeight) > parseInt(weight?.upper_ThresholdWeight)))}
                                            handleOnChangeInput={handleOnChangeWeight}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='xl:w-1/4 min-w-[210px] max-w-[210px] xl:min-w-[25%] px-2 mb-[22px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title='Upper Threshold*'>Upper Threshold*</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox
                                            label={""}
                                            placeholder={"Enter threshold"}
                                            id={'upper_ThresholdWeight'}
                                            htmlFor={"upper_ThresholdWeight"}
                                            isUnit={true}
                                            unitType={((edit&&weight?.unit)|| weight?.unit!=="" && weight.unit!==undefined)? weight?.unit : unittype5}
                                            value={weight?.upper_ThresholdWeight}
                                            emptyField={(isWeightCheckboxChecked && emptyField && weight?.upper_ThresholdWeight.trim() === "") || (submitSelected && (parseInt(weight?.lower_ThresholdWeight) > parseInt(weight?.upper_ThresholdWeight)))}
                                            handleOnChangeInput={handleOnChangeWeight}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                </div>
            </div>
        
                                   
        </>
    )
}
